import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const NONE = "__none";

/** Input for one category-specific spec field. Empty means "unknown" (null), never 0. */
export default function SpecInput({ field, value, onChange, prefix = "spec" }) {
  const tid = `${prefix}-input-${field.key}`;
  if (field.type === "number")
    return (
      <Input data-testid={tid} type="number" step="any" placeholder="Bilinmiyor" value={value ?? ""}
        onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))} />
    );
  if (field.type === "boolean")
    return (
      <Select value={value === true ? "yes" : value === false ? "no" : NONE}
        onValueChange={(v) => onChange(v === NONE ? null : v === "yes")}>
        <SelectTrigger data-testid={tid}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>Bilinmiyor</SelectItem><SelectItem value="yes">Evet</SelectItem><SelectItem value="no">Hayır</SelectItem>
        </SelectContent>
      </Select>
    );
  if (field.type === "select")
    return (
      <Select value={value ?? NONE} onValueChange={(v) => onChange(v === NONE ? null : v)}>
        <SelectTrigger data-testid={tid}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>Bilinmiyor</SelectItem>
          {field.options?.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
        </SelectContent>
      </Select>
    );
  if (field.type === "multiselect") {
    const arr = Array.isArray(value) ? value : [];
    return (
      <div className="flex flex-wrap gap-1.5" data-testid={tid}>
        {field.options?.map((o) => {
          const on = arr.includes(o);
          return (
            <button type="button" key={o} data-testid={`${tid}-${o}`}
              onClick={() => { const next = on ? arr.filter((x) => x !== o) : [...arr, o]; onChange(next.length ? next : null); }}
              className={`rounded-full border px-2 py-1 text-xs ${on ? "border-[#0071e3] bg-[#0071e3]/15 text-orange-700" : "border-black/[0.08] text-zinc-500"}`}>
              {o}
            </button>
          );
        })}
      </div>
    );
  }
  return <Input data-testid={tid} placeholder="Bilinmiyor" value={value ?? ""} onChange={(e) => onChange(e.target.value || null)} />;
}

export function BoolFilter({ checked, onChange, testId }) {
  return <Switch data-testid={testId} checked={!!checked} onCheckedChange={onChange} />;
}
